/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { InputHTMLAttributes, Ref, forwardRef } from 'react';
import InputMask from 'react-input-mask';
import clsx from 'clsx';

import FormControl from '../FormControl';
import { generateTestId } from './data';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  dataTestId: string;
  label?: string;
  hasError?: boolean;
  legend?: string;
  disabled?: boolean;
  className?: string;
  mask?: string;
}

const Input = forwardRef(
  (
    { label, hasError, dataTestId, legend, disabled, className, mask, ...rest }: InputProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    const testIds = generateTestId(dataTestId);

    return (
      <FormControl
        label={label}
        hasError={hasError}
        legend={legend}
        dataTestId={testIds.component}
        disabled={disabled}
        htmlFor={rest.id as string}
      >
        {mask ? (
          <InputMask
            {...rest}
            mask={mask || ''}
            className={clsx(
              className,
              'w-full p-2 rounded-lg border focus:border-primary-400 focus:outline-none transition duration-300 ease-in-out',
              {
                'border-red-700 text-red-700': hasError,
                'bg-slate-200': disabled,
                'text-slate-500': disabled,
              },
            )}
            data-testid={testIds.input}
            disabled={disabled}
            inputRef={ref}
          >
            {(inputProps: any) => <input {...inputProps} />}
          </InputMask>
        ) : (
          <input
            {...rest}
            ref={ref}
            className={clsx(
              className,
              'w-full p-2 rounded-lg border focus:border-primary-400 focus:outline-none transition duration-300 ease-in-out',
              {
                'border-red-700 text-red-700': hasError,
                'bg-slate-200': disabled,
                'text-slate-500': disabled,
              },
            )}
            data-testid={testIds.input}
            disabled={disabled}
          />
        )}
      </FormControl>
    );
  },
);

Input.displayName = 'Input';
export default Input;
